import { Link } from "react-router-dom";

export default function ClosingCTA() {
    return (
        <section style={{ backgroundColor: "hsl(var(--bg-chalk))" }}>
            <div className="ihx-container py-20 lg:py-28">
                <div
                    className="relative overflow-hidden rounded-[32px] px-7 py-14 md:px-14 md:py-20 lg:px-20 lg:py-24 text-[hsl(var(--bg-chalk))]"
                    style={{
                        background:
                            "radial-gradient(50% 90% at 100% 0%, hsl(var(--brand-gold) / 0.35) 0%, transparent 55%), radial-gradient(50% 80% at 0% 100%, hsl(var(--brand-gold) / 0.2) 0%, transparent 55%), hsl(var(--brand-ink-deep))",
                    }}
                >
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
                        <div className="lg:col-span-8">
                            <span className="ihx-eyebrow" style={{ color: "hsl(var(--brand-gold-soft))" }}>
                                A 10-minute discovery
                            </span>
                            <h2 className="font-serif text-[36px] md:text-[52px] leading-[1.02] mt-5 max-w-2xl tracking-[-0.02em] text-[hsl(var(--bg-chalk))]">
                                The most useful thing you can do for your next forty years is the next <span className="ihx-italic" style={{ color: "hsl(var(--brand-gold))" }}>ten minutes.</span>
                            </h2>
                            <p className="mt-6 text-[15.5px] leading-[1.7] text-[hsl(var(--bg-chalk))]/75 max-w-xl">
                                The Discovery Form establishes your clinical baseline and tells Dr. Hanspal’s team exactly how to design your first consultation. Encrypted, private, and reviewed personally.
                            </p>
                        </div>
                        <div className="lg:col-span-4 flex lg:justify-end">
                            <Link
                                to="/apply"
                                className="ihx-btn-primary"
                                style={{
                                    backgroundColor: "hsl(var(--brand-gold))",
                                    borderColor: "hsl(var(--brand-gold))",
                                }}
                            >
                                Apply for Consultation
                                <span className="ihx-arrow" aria-hidden>→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
